import React, { Component } from 'react'
import Timesheet, { StatusView, GetProjectTaskNames, TimesheetStatus, TimesheetChange } from 'src/components/timesheet'
import GroupedList, { GroupData, GroupDataItem } from 'src/components/grouped-list'
import SplitterLayout from 'react-splitter-layout'
import 'react-splitter-layout/lib/index.css'
import windowSize, { WindowSizeProps } from 'react-window-size'
import { Divider, Empty, Alert, Row, Col, Card, Spin, Modal, Radio, Select, Input, Button, Dropdown, Menu, Icon, Progress, Tooltip, Checkbox, notification, Badge, Collapse } from 'antd'
import autobind from 'autobind-decorator'
import moment from 'moment'
import HttpService, { formatMessage } from 'src/core/services/http.service'
import FileSaver from 'file-saver'
import { resolve } from 'src/inversify.config'
import { unixEpochToDate, formatCurrency, formatDecimal } from 'src/core/utils/object'
import { CommandResult } from 'src/core/stores/types'
import ContentTitle from 'src/core/ui/content-header'
import { withTranslation, WithTranslation } from 'react-i18next'
import { WrapperProjectTaskEditor } from 'src/components/projecttask-editor'
import { CompanySummary } from 'src/stores/companies-store'
import { ProjectSummary } from 'src/stores/projects-store'
import Tour from 'reactour'
import steps from 'src/components/virtual-tour/virtual-tour-configs'
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'
import { DataStore, Query } from 'src/core/stores/dataStore'
import { EmployeeSummary } from 'src/stores/employees-store'
import { IdentityProps, withIdentity } from "src/core/services/authentication"
import EditableTooltip from 'src/components/editable-tooltip/tooltip'
import { CacheProps, TimeType, withCache } from 'src/core/services/cache.service'
const { Option } = Select
import 'src/core/assets/site.less'
import 'src/pages/timesheet/timesheet.less'
import { notificationService, withNotification } from 'src/consumer/notificationContent'
import MyReportsView from 'src/pages/user/my-reports'
import CreateSpecificTimeSheet from 'src/components/createSpecificTimeSheet'
import { TimesheetsStore } from 'src/stores/timesheets-store'
import { withUserProfile, UserProfileProps, companyProfile } from 'src/components/user-profile'
import { extend } from 'lodash'
import CustomLoad from 'src/components/customLoad'
import { RouteComponentProps, withRouter } from 'react-router'


const timesheetsStore = new TimesheetsStore()
let Search = Input.Search

interface TimesheetSummary {
  id: string,
  employeeId: string,
  employeeTitle: string,
  fromDate: Date,
  toDate: Date,
  status: TimesheetStatus,
  totalHours: number
  minHours: number
  maxHours: number
}

interface TimesheetTaskEntryItem {
  day: number,
  planned: number,
  hours: number,
  notes: string,
}

export interface TimesheetTaskItem {
  projectTaskId: string,
  projectTaskTitle: string,
  projectId: string,
  projectTitle: string,
  isFavorite: boolean,
  title: string,
  notes: string,
  entries: TimesheetTaskEntryItem[],
  disabledForEmployee: boolean
}

interface TimesheetItem extends TimesheetSummary {
  tasks: TimesheetTaskItem[]
}

interface TimesheetPageProps extends IdentityProps, UserProfileProps, RouteComponentProps, CacheProps {
  handleResetSuccessAddTask?: () => void
  notifications: any
}

interface TimesheetPageStatus {
  timesheets: TimesheetSummary[],
  timesheetIdToIndex: Map<string, number>,
  timesheet: TimesheetItem | undefined,
  companies: any[],
  employeeId: string | undefined,
  employeeTitle: string,
  companyId: string | undefined,
  companyTitle: string,
  currency: string,
  allowCir: boolean,
  allowCii: boolean,
  isBusy: boolean
  isLoading: boolean
  error: string | undefined
  addNewTaskShown: boolean
  canApproveTimesheets: boolean
  isCompanyManager: boolean
  hasRoleAdminOrManager: boolean
  employeeFilter: string
  employeesFilter: string[]
  groups: any[]
  sortDirectionUp: boolean
  sortByDate: boolean
  periodFilter: string[]
  originalGroups: any[]
  incompleteSheets: boolean
  firstEntry: boolean
  projectsFilter: string[]
  allProjects: string[]
  projectIdToSummary: Map<string, ProjectSummary>
  prev1: any
  groupReversed: boolean
  hasEmployeePlan?: boolean
  employeeMinHours: number[]
  employeeMaxHours: number[]
  isTourOpen: boolean
  fromDateTimesheet: number
  toDateTimesheet: number
  pendingTimesheets: number
  statusFilter: string[]
  selectedTimesheetHasChanges: boolean
  selectedNewTimesheet: any
  openConfirmationModal: boolean
  selectedItems: any[]
  errorMessage: string
  showError: boolean
  showBtnCreateTimeSheet: boolean
  companyHoursManager: boolean
  isRoleManager: boolean
  handleSuccessAddTask?: () => void
  handleResetSuccessAddTask?: () => void

}


class AddNewTaskView extends Component<any, any> {
  constructor(props: any) {
    super(props)
    this.state = {
      projectTaskIds: [],
      taskIds: [],
      checkAllTaskByProject: false,
      showError: false,
      companyHoursManager: null,

    }
  }

  handleOk = () => {
    if (this.state.projectTaskIds) {
      const ids = this.state.checkAllTaskByProject ? [this.state.projectTaskIds] : this.state.taskIds
      this.props.onOk(ids, this.state.checkAllTaskByProject).then((success: number[]) => {
        if (this.state.projectTaskIds.length != success.length) {
          this.setState({ showError: true, projectTaskIds: success })
        }
      })
    }
  }

  onChangeTaskIds = (value: any) => { this.setState({ taskIds: value }) }
  onChangeCheckAllTaskByProject = (value: any) => {
    if (value) {
      this.setState({ taskIds: [] })
    }
    this.setState({ checkAllTaskByProject: value })
  }

  render() {
    const { t } = this.props
    return <Modal
      visible
      title={this.props.t('Add new project')}
      onOk={() => {
        this.handleOk()
      }}
      okText={t("OK")}
      cancelText={t("Cancel")}
      onCancel={this.props.onCancel}>

      {this.state.showError && <Alert type="error" message={t("Error adding some projects/tasks")} banner />}

      <WrapperProjectTaskEditor
        companyAllowCir={this.props.companyAllowCir}
        companyAllowCii={this.props.companyAllowCii}
        newProjectTaskCallback={(id: any) => {
          if (!this.state.projectTaskIds.includes(id)) {
            this.setState({ projectTaskIds: [...this.state.projectTaskIds, id] })
            this.handleOk()
          }
        }}
        toShow={this.state.projectTaskIds}
        nullable
        placeholder={t('Select a project')}
        companyId={this.props.companyId}
        employeeId={this.props.employeeId}
        includeProjectName
        onChange={(value: any) => this.setState({ projectTaskIds: value })}
        canAddNewProjectsTask={this.props.canAddNewProjectsTask}
        multiple={true}
        fromDate={this.props.fromDate}
        toDate={this.props.toDate}
        onSave={() => {
          if (this.state.projectTaskIds) {
            this.props.onOk(this.state.projectTaskIds)
            this.handleOk()
          }
        }}
        showSelectProject={true}
        isOnlyUser={this.props.isOnlyUser}
        closeAllModal={this.props.onCancel}
        onChangeTaskIds={this.onChangeTaskIds}
        onChangeCheckAllTaskByProject={this.onChangeCheckAllTaskByProject}
      />
    </Modal>
  }
}

class TimesheetPage extends Component<TimesheetPageProps & WindowSizeProps & WithTranslation & CacheProps, TimesheetPageStatus> {
  timesheet?: TimesheetItem

  @resolve(HttpService)
  private httpService!: HttpService

  constructor(props: TimesheetPageProps & WindowSizeProps & WithTranslation & CacheProps) {
    super(props)
    this.state = {
      timesheet: undefined,
      employeeId: undefined,
      employeeTitle: "",
      companyTitle: "",
      currency: '\u20AC',
      allowCir: false,
      allowCii: false,
      companies: [],
      companyId: undefined,
      timesheets: [],
      timesheetIdToIndex: new Map(),
      error: undefined,
      isBusy: true,
      addNewTaskShown: false,
      canApproveTimesheets: false,
      isCompanyManager: false,
      hasRoleAdminOrManager: false,
      employeeFilter: '',
      employeesFilter: [],
      groups: [],
      sortDirectionUp: false,
      groupReversed: false,
      sortByDate: true,
      periodFilter: [],
      originalGroups: [],
      incompleteSheets: false,
      firstEntry: false,
      allProjects: [],
      projectIdToSummary: new Map(),
      projectsFilter: [],
      employeeMinHours: [],
      employeeMaxHours: [],
      prev1: undefined,
      isTourOpen: false,
      fromDateTimesheet: 0,
      toDateTimesheet: 253402300799,
      statusFilter: [],
      pendingTimesheets: 0,
      selectedTimesheetHasChanges: false,
      selectedNewTimesheet: undefined,
      openConfirmationModal: false,
      selectedItems: [] as any,
      errorMessage: "",
      showError: false,
      showBtnCreateTimeSheet: false,
      companyHoursManager: false,
      isRoleManager: false,
      isLoading: true
    }
    this.timesheet = undefined
  }

  componentDidMount() {
    this.loadEmployeeId();
  }


  private taskComparer(t1: TimesheetTaskItem, t2: TimesheetTaskItem) {
    if ((t1.isFavorite && t2.isFavorite) || (!t1.isFavorite && !t2.isFavorite)) {
      var n1 = t1.title.toUpperCase()
      var n2 = t2.title.toUpperCase()
      return (n1 > n2) ? 1 : ((n1 < n2) ? -1 : 0)
    }
    return t1.isFavorite ? -1 : 1
  }

  @autobind
  private setIsTourOpen(state: boolean) {
    this.setState({ isTourOpen: state })
  }

  @autobind
  private disableBody(e: any) {
    disableBodyScroll(e.target)
  }

  @autobind
  private enableBody(e: any) {
    enableBodyScroll(e.target)
  }

  private extractNameFromFullName(fullName: any) {
    const nameAndEmail = fullName.match(/^(.*?)\s+\((.*)\)$/)

    if (nameAndEmail && nameAndEmail.length > 1 && nameAndEmail[1].trim() !== '') {
      return nameAndEmail[1].trim()
    }

    const nameInParentheses = fullName.match(/\((.*?)\)/)

    if (nameInParentheses && nameInParentheses.length > 1) {
      return nameInParentheses[1].trim()
    }

    return fullName.trim()
  }

  @autobind
  private onDashboardChanged(dashboard: 'user-timesheet' | 'team-timesheets' | 'user-my-reports') {

    if (dashboard == 'user-timesheet') {
      this.props.history.push("/time-tracking/my-timesheet")
    }

    if (dashboard == 'team-timesheets') {

      this.props.history.push("/time-tracking/my-team-timesheet")
    }
  }

  private getCurrencySymbol(currency: string) {
    switch (currency) {
      case "USD":
        return "$"
      case "EUR":
        return '\u20AC'
      case "BRL":
        return "R$"
      case "GBP":
        return '\u00A3'
      default:
        return '\u20AC'
    }
  }


  @autobind
  private async loadEmployeeId() {
    var self = this
    this.setState({ isBusy: true })
    var companies = this.props.userProfile.companies
    if (!companies || companies.length == 0) {
      self.setState({
        isBusy: false,
        employeeId: undefined
      })
    } else {
      let currentCompanyGuid = this.props.cache.getGlobal("PMO-SELECTED-COMPANY")
      let currentCompany = currentCompanyGuid && companies.any(x => x.companyId == currentCompanyGuid) ? companies.filter((o: any) => o.companyId == currentCompanyGuid).first() : undefined
      if (!currentCompany)
        currentCompany = self.state.companyId == null ? companies[0] : companies.filter((o: any) => o.companyId == self.state.companyId)[0]
      self.setState({
        isBusy: false,
        companies: companies.map((o: any) => ({
          id: o.companyId,
          title: o.companyTitle,
          employeeId: o.employeeId,
          employeeTitle: o.employeeTitle,
          isManager: o.isManager,
          cirEligible: o.cirEligible,
          ciiEligible: o.ciiEligible,
          currency: o.currency,
        })),
        employeeId: currentCompany.employeeId,
        pendingTimesheets: currentCompany.pendingCount,
        employeeTitle: currentCompany.employeeTitle,
        companyId: currentCompany.companyId,
        companyTitle: currentCompany.companyTitle,
        currency: this.getCurrencySymbol(currentCompany.currency),
        allowCir: currentCompany.cirEligible,
        allowCii: currentCompany.ciiEligible,
        canApproveTimesheets: currentCompany.isManager,
        isCompanyManager: currentCompany.isCompanyManager,
        hasRoleAdminOrManager: currentCompany.hasRoleAdminOrManager
      })
    }

  }



  @autobind
  private onCompanyChange(companyId: string) {
    var companies = this.props.userProfile.companies
    let currentCompany = companyId && companies.any(x => x.companyId == companyId) ? companies.filter((o: any) => o.companyId == companyId).first() : undefined
    if (!currentCompany)
        currentCompany = companyId == null ? companies[0] : companies.filter((o: any) => o.companyId == companyId)[0]
    this.props.cache.saveGlobal("PMO-SELECTED-COMPANY", companyId, { type: TimeType.Days, value: 9999999 })
    this.timesheet = undefined

    this.setState({
      companyId: currentCompany.companyId,
      companyTitle: currentCompany.companyTitle,
      currency: this.getCurrencySymbol(currentCompany.currency),
      allowCir: currentCompany.cirEligible,
      allowCii: currentCompany.ciiEligible,
      employeeId: currentCompany.employeeId,
      employeeTitle: currentCompany.employeeTitle,
      periodFilter: [],
      projectsFilter: [],
      incompleteSheets: false,
      statusFilter: [],
      employeeFilter: '',
      employeesFilter: [],
      timesheet: undefined,
      canApproveTimesheets: currentCompany.isManager,
      hasRoleAdminOrManager: currentCompany.hasRoleAdminOrManager
    })
  }



  render() {
    const { t, i18n } = this.props


    if (!this.state.employeeId) {
      return <Empty description={t("There is no timesheet for you available yet. Please contact your manager.")} />
    }
    const sideSize = this.props.windowWidth <= 1024 ? 290 : 290
    const { Panel } = Collapse
    const filterHeader = (<h5 style={{ marginTop: 6 }} >{t('Advanced search')} </h5>)
    let employeeTitle = this.extractNameFromFullName(this.state.employeeTitle)

    return <div style={{ marginTop: -20 }} data-tut="reactour__content">
        <Row gutter={0}>
          <Col span={12}>
            {this.state.timesheet && < Tour
              steps={this.state.hasRoleAdminOrManager && this.state.companyId ? steps(t).stepsAdmin : steps(t).stepsUser}
              isOpen={this.state.isTourOpen}
              onRequestClose={() => this.setIsTourOpen(false)}
              onAfterOpen={this.disableBody}
              onBeforeClose={this.enableBody}
            />}
            {!this.state.timesheet && < Tour
              steps={this.state.hasRoleAdminOrManager && this.state.companyId ? steps(t).stepsAdminNoTimesheets : steps(t).stepsNewUser}
              isOpen={this.state.isTourOpen}
              onRequestClose={() => this.setIsTourOpen(false)}
              onAfterOpen={this.disableBody}
              onBeforeClose={this.enableBody}
            />}
          </Col>
        </Row>

        <Row gutter={0}>
          <Col span={10}>
            <ContentTitle title={employeeTitle || ""} type={this.state.companyTitle || ""} />
          </Col>
          <Col span={14} style={{ marginTop: 10 }}>
            <Row>

            </Row>
            <Row><Button data-tut="reactour__init" style={{ float: "right" }} type={"link"} onClick={() => this.setIsTourOpen(true)} icon={'caret-right-fill'}>  {t("Discover Time Tracking")} </Button></Row>
            <Row><Dropdown
              trigger={['click']}
              placement={"bottomRight"}
              overlay={<Menu onClick={(param) => this.onCompanyChange(param.key)}>{this.state.companies.map(c => <Menu.Item key={c.id}>{c.title}</Menu.Item>)}</Menu>}>
              <Button data-tut="reactour__changeCompany" style={{ minWidth: 120, float: 'right', textAlign: 'left', lineHeight: '30px' }}>{this.state.companyTitle}<Icon type={"down"} style={{ float: 'right', lineHeight: '32px' }} /></Button>
            </Dropdown>
              <Radio.Group style={{ float: 'right' }} onChange={(e) => this.onDashboardChanged(e.target.value)} value={'user-my-reports'}>
                <Radio.Button key="user-timesheet" value="user-timesheet">
                  <span data-tut="reactour__myTimesheets"> {t("My timesheets")}</span>
                </Radio.Button>
                {this.state.canApproveTimesheets && this.state.hasRoleAdminOrManager &&
                  <Radio.Button key="team-timesheets" value="team-timesheets">
                    <EditableTooltip name="principal-myteam">
                      <Badge offset={[20, -10]} count={this.state.pendingTimesheets}>
                        <span data-tut="reactour__teamTimesheets">{t("My team's timesheets")}</span>
                      </Badge>
                    </EditableTooltip>
                  </Radio.Button>}
                <Radio.Button style={{ background: "rgb(0,0,164)", cursor: 'default', color: "white" }} key="user-my-reports" value="user-my-reports">
                  <span data-tut="reactour__myReports">
                    {t("My Reports")}
                  </span>
                </Radio.Button>
              </Radio.Group>
            </Row>
          </Col>
        </Row>
        <Row>
          <MyReportsView
            companyTitle={this.state.companyTitle}
            companyId={this.state.companyId!}
            employeeTitle={employeeTitle}
            employeeId={this.state.employeeId}
            currency={this.state.currency}
            allowCir={this.state.allowCir}
            allowCii={this.state.allowCii}
          />
        </Row>
      </div>
  }
}
export default withRouter(withUserProfile(withCache(withNotification(withIdentity(withTranslation()(windowSize(TimesheetPage)) as any) as any) as any) as any) as any) as any as React.ComponentClass<TimesheetPageProps>